import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Box, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';
import FieldView2 from 'core/components/layout/FieldView2';
import EditIcon from '@mui/icons-material/Edit';
import { updateMfproductorderInfo } from 'components/mfproductorder/MfproductorderAPI';
import { updateMfproductorderObj } from 'store/slice/ManufSlice';
import { transformDateValue } from 'core/js/FormUtils';

export default function MfproductorderInfo() {
  const dispatch = useDispatch();
  const { taskinstanceObj } = useSelector((state) => state.manufslice.taskinstanceDashboard);
  const { mfproductorderList } = useSelector((state) => state.manufslice);
  const { mfproductorderObj } = useSelector((state) => state.manufslice.mfproductorderDashboard);

  const [productOrder, setProductOrder] = useState({});
  const [open, setOpen] = useState(false);
  const [dispatchDate, setDispatchDate] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    console.log("mfproductorderObj=>", mfproductorderObj);
    // const index = mfproductorderList.findIndex(
    //   mfproductorder =>
    //     mfproductorder.orderid === taskinstanceObj.orderid &&
    //     mfproductorder.productid === taskinstanceObj.productid
    // );
    setProductOrder(mfproductorderObj);
    setDispatchDate(mfproductorderObj?.dispatchdate || '');
  }, [mfproductorderList, taskinstanceObj]);

  useEffect(() => {
    if (mfproductorderObj){
      setDispatchDate(mfproductorderObj.dispatchdate?mfproductorderObj.dispatchdate.split('T')[0]:'');
    }
  },[mfproductorderObj]);

  const getRenderingComponent = () => {
    if (productOrder.stockready) {
      if (productOrder.withprinting) {
        return (
          <Grid item lg={3} xs={4}>
            <FieldView2 color="white" label="Printing Type" value={productOrder.printingtype ? 'Digital' : 'Screen'} />
          </Grid>
        );
      }
    } else {
      return (
        <>
          <Grid item lg={3} xs={4}>
            <FieldView2 color="white" label="Stiching Type" value={productOrder.stichingtype ? 'Simple' : 'Complex'} />
          </Grid>
          <Grid item lg={3} xs={4}>
            <FieldView2 color="white" label="Printing Type" value={productOrder.printingtype ? 'Digital' : 'Screen'} />
          </Grid>
        </>
      );
    }
  };

  const handleEditClick = () => {
    console.log("mfproductorderObj.dispatchdate=>"+mfproductorderObj.dispatchdate);
    setDispatchDate(mfproductorderObj.dispatchdate?mfproductorderObj.dispatchdate.split('T')[0]:'');
    setOpen(true);
  };

  const handleSave =  () => {
    setSaving(true);
    updateMfproductorderInfo(
      mfproductorderObj.id,{
      dispatchdate: dispatchDate
    },
    (response) => {
       setSaving(false);
      dispatch(updateMfproductorderObj(response))
      setOpen(false)
    }, (error) => {
      setSaving(false);
      console.error("Error updating product order:", error);
    });
  };

  return (
    <Box lg={12} sx={{ flexGrow: 1 }}>
      <Grid>
        <Typography variant="h5" color="primary.darker">
          Product Info
        </Typography>
      </Grid>
      <Grid item sx={{ overflowY: 'scroll', backgroundColor: 'white', maxHeight: { xs: '20vh', lg: '60vh' } }}>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          sx={{ backgroundColor: 'white' }}
        >
          <Grid item lg={3} xs={4}>
            <FieldView2 color="white" label="Product" value={productOrder.productname ?? 'NOT KNONWN'} />
          </Grid>
          <Grid item lg={5} xs={4}>
            <FieldView2 color="white" label="Matter" value={productOrder.matter ?? 'NOT KNONWN'} />
          </Grid>
          <Grid item lg={1} xs={4}>
            <FieldView2 color="white" label="Qty" value={productOrder.qty ?? 'NOT KNONWN'} />
          </Grid>
          {getRenderingComponent()}
          <Grid item lg={3} xs={4}>
            <Grid container justifyContent="space-between">
              <Grid item lg={8} xs={8}>
                <FieldView2 color="white" label="Dispatch Date" value={productOrder.dispatchdate ? transformDateValue(productOrder.dispatchdate) : '-'} />
              </Grid>
              <Grid item lg={4} xs={4}>
                 <EditIcon sx={{ cursor: 'pointer' }} onClick={handleEditClick} />
              </Grid>
            </Grid>
            
           
          </Grid>
          
          <Grid item lg={12} xs={7}>
            <FieldView2 color="white" label="Remarks" value={productOrder.remarks} />
          </Grid>
          
          
        </Grid>
      </Grid>

      {/* Dispatch Date Edit Dialog */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        PaperProps={{
          sx: { minWidth: 300 }
        }}
      >
        <DialogTitle>Edit Dispatch Date</DialogTitle>
        <DialogContent>
          <TextField
            label="Dispatch Date"
            type="date"
            value={dispatchDate || ''}
            onChange={e => setDispatchDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            fullWidth
            sx={{ mt: 2 }}
            inputProps={{
              max: new Date().toISOString().split('T')[0]
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} disabled={saving}>Cancel</Button>
          <Button onClick={handleSave} variant="contained" disabled={dispatchDate === ''}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}